<cc-single-select-dropdown
    cssClass="picklist"
    [anchorType]="'grid'"
    [matchAnchorWidth]="true"
    [autoScrollSelectedIntoView]="true"
    [allowNoSelection]="true"
    [options]="dropdownOptions"
    [selected]="value ? {text: value, value} : undefined"
    (selectedChange)="updateDropdownValue($event)"
>
</cc-single-select-dropdown>
